import { SettingOutlined } from '@ant-design/icons';
import { Avatar, Tooltip } from 'antd';
import type { AvatarProps } from 'antd/es/avatar';
import { FC } from 'react';

import styles from './styles.modules.less';

const SystemAvatar: FC<AvatarProps> = (props) => {
  return (
    <Tooltip title="System">
      <Avatar
        className={styles.avatar}
        icon={<SettingOutlined />}
        size={20}
        {...props}
      />
    </Tooltip>
  );
};

export default SystemAvatar;
